import { render } from "./SearchSidebar.vue?vue&type=template&id=667a6a9e&scoped=true"
import script from "./SearchSidebar.vue?vue&type=script&lang=js"
export * from "./SearchSidebar.vue?vue&type=script&lang=js"

import "./SearchSidebar.vue?vue&type=style&index=0&id=667a6a9e&lang=scss&scoped=true"

import exportComponent from "/builds/initiative/engineering/man_core/man-intelligence-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-667a6a9e"]])

export default __exports__
import QDrawer from 'quasar/src/components/drawer/QDrawer.js';
import QItem from 'quasar/src/components/item/QItem.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QDrawer,QItem,QBtn});
